import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'text-text-main-inversion bg-gray-900 px-4 py-6 md:p-12',
    container: [
      'mx-auto flex flex-wrap gap-10',
      'max-md:flex-col-reverse',
      'md:items-center md:justify-between md:gap-6'
    ],

    left: 'flex flex-col gap-4 max-md:w-full',
    logo: 'block',
    logoIcon: 'h-8 w-45 md:h-10 md:w-56.5',

    right: 'flex flex-wrap gap-6 md:gap-12',

    title: 'heading-s-bold text-text-main-inversion',
    text: 'heading-xs text-gray-500',
    link: 'hover:text-brand-primary heading-xs text-gray-500',
    column: 'flex flex-col gap-2'
  }
});
